/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLupin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M8 11c-1.79 0-3.296 1.071-4.304 2.282C2.694 14.486 2 16.043 2 17.354c0 1.405.783 2.59 1.875 3.386C4.97 21.537 6.43 22 8 22s3.031-.463 4.125-1.26C13.217 19.944 14 18.76 14 17.354c0-1.311-.694-2.868-1.696-4.072C11.296 12.072 9.791 11 8 11zm-4 6.354c0-.662.379-1.698 1.102-2.629C5.847 15.444 6.84 16 8 16s2.153-.556 2.898-1.275c.723.931 1.102 1.967 1.102 2.63 0 .608-.337 1.246-1.054 1.77C10.23 19.645 9.192 20 8 20s-2.23-.354-2.946-.876C4.337 18.601 4 17.964 4 17.354zM8 13c.468 0 .942.14 1.397.392C8.963 13.77 8.47 14 8 14s-.963-.23-1.397-.608C7.058 13.139 7.532 13 8 13zm8-11c-1.79 0-3.296 1.071-4.304 2.282C10.694 5.486 10 7.043 10 8.354c0 1.405.783 2.59 1.875 3.386C12.97 12.538 14.43 13 16 13s3.031-.462 4.125-1.26C21.217 10.944 22 9.76 22 8.354c0-1.311-.694-2.868-1.696-4.072C19.296 3.072 17.791 2 16 2zm-2.898 3.725C13.847 6.444 14.84 7 16 7s2.153-.556 2.898-1.275C19.621 6.656 20 7.692 20 8.355c0 .608-.337 1.246-1.054 1.77-.716.521-1.754.875-2.946.875s-2.23-.354-2.946-.876C12.337 9.601 12 8.964 12 8.354c0-.662.379-1.698 1.102-2.629zm4.295-1.333C16.963 4.77 16.47 5 16 5s-.963-.23-1.397-.608C15.058 4.139 15.532 4 16 4s.942.14 1.397.392z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLupin as Lupin };
